// Vendor Libraries
import React, {Component} from 'react';
import PropTypes from 'prop-types';

// Components
import Permissions from '../core/permissions';
import SearchRecordDetails from '../app/search-record-details';

// Containers
import withSearch from '../../containers/with-search';

const servicesDataKey = 'providerDetail';

class ProviderDetail extends Component {
    getSearchRecordDetailProps() {
        return {
            ...this.props,
            blacklistKeys: ['providerId', 'version'],
            keyOrder: 'providers',
            servicesDataKey,
            whitelistKeys: [
                'name',
                'partnerId',
                'playerType',
                'guid',
                'dateCreated',
                'createdBy',
                'lastUpdated',
                'lastModifiedBy',
            ],
        };
    }

    render() {
        return (
            <Permissions
                accessRequirement="read"
                elementService="provider"
                notAuthorizedMessage={true}
                requiresServiceAccess={true}
            >
                <div className="provider-detail">
                    <SearchRecordDetails {...this.getSearchRecordDetailProps()} />
                </div>
            </Permissions>
        );
    }
}

ProviderDetail.propTypes = {
    searchData: PropTypes.array.isRequired,
};

export default withSearch(ProviderDetail, servicesDataKey);
